import React, { useState, useEffect, useCallback } from 'react';
import axiosApi from '../Utils/axiosApi';
import checkPermission from '../Utils/checkPermission';
import {
  
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  
  Alert,
  Grid ,
 
  IconButton,
 TextField,
  Stack,
  Pagination
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';



import { useTable, usePagination, useRowSelect } from 'react-table';
import HeaderMenu from '../Header/HeaderMenu';
import CreateHostel from '../HostelDetails/CreateHostel';
import CreateHostelMenu from '../HostelDetails/CreateHostelMenu';
import { API_BASE_URL } from '../../config';
import HolidayDialog from '../HostelDetails/HolidayDialog';
import './HostelList.css';

const HostelList = () => {
  const [hostelList, setHostelList] = useState([]);
  const [data, setData] = useState([]);
  const [hostelerList] = useState([]);
  const [cities, setCities] = useState([]);

  const [loading, setLoading] = useState(true);
  const [deleteMessage, setDeleteMessage] = useState('');
  const [menuErrorMessage, setMenuErrorMessage] = useState('');

  const [openDetails, setOpenDetails] = useState(false);
  const [selectedHostelDetails, setSelectedHostelDetails] = useState(null);

  const [openMenu, setOpenMenu] = useState(false);
  const [selectedHostelMenu, setSelectedHostelMenu] = useState(null);

  const [pendingHostelFilter, setPendingHostelFilter] = useState('');
  const [pendingHostelerFilter, setPendingHostelerFilter] = useState('');
  const [formData, setFormData] = useState({ cityId: '' });
const [deleteConfirmId, setDeleteConfirmId] = useState(null);
const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

//const [selectedHostelHoliday, setSelectedHostelHoliday] = useState(null);
//const [openHolidayDialog, setOpenHolidayDialog] = useState(false);
const [selectedHostelId, setSelectedHostelId] = useState(null);
const [openOccupancyDialog, setOpenOccupancyDialog] = useState(false);
const [roomTypes, setRoomTypes] = useState([]);
const [selectedHostelForOccupancy, setSelectedHostelForOccupancy] = useState(null);
const [occupancyLoading, setOccupancyLoading] = useState(false);

const [banner, setBanner] = useState({
  open: false,
  type: "success", // success | error
  message: ""
});

const [saving, setSaving] = useState(false);

const hasPermission = checkPermission(
  "Hostel",
  "Hostel List",
  "UPDATEROOMOCCUPANCY"
);
useEffect(() => {
  if (openOccupancyDialog) {
    setBanner({
      open: false,
      type: "success",
      message: ""
    });
  }
}, [openOccupancyDialog]);

  useEffect(() => {
    axiosApi.post('/hostel/getHostels', {}).then((res) => {
      const hostels = Array.isArray(res.data) ? res.data : [];
      setHostelList(hostels);
      setData(hostels);
      setLoading(false);
    });
  }, []);

 /* const handleCloseDialog = () => {
  setSelectedHostelMenu(null); // clear previous menu data
  setMenuErrorMessage('');      // clear any warning
  setOpenMenu(false);           // close the dialog
};*/



  useEffect(() => {
    axiosApi.post('/city/getCity', {})
      .then((response) => {
        const cityArray = Array.isArray(response.data) ? response.data : response.data.cities || [];
        setCities(cityArray);
      })
      .catch((error) => {
        console.error('Error fetching cities:', error);
        setCities([]);
      });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = async () => {
  const hostelIds = pendingHostelFilter
    ? hostelList
        .filter(h => h.hostelName === pendingHostelFilter)
        .map(h => h.id)
    : [];

  const cityIds = formData.cityId ? [formData.cityId] : [];

  const searchCriteria = {
    hostelSearchCriteria: {}
  };

  if (hostelIds.length > 0) {
    searchCriteria.hostelSearchCriteria.hostelIds = hostelIds;
  }

  if (cityIds.length > 0) {
    searchCriteria.hostelSearchCriteria.cityIds = cityIds;
  }

  try {
    const response = await axiosApi.post('/hostel/getHostels', searchCriteria);
    let result = Array.isArray(response.data) ? response.data : [];

    // Additional filtering by hosteler name (client-side)
    if (pendingHostelerFilter) {
      result = result.filter(h =>
        hostelerList.some(hosteler =>
          hosteler.hostelName === h.hostelName &&
          hosteler.hostelerName?.toLowerCase().includes(pendingHostelerFilter.toLowerCase())
        )
      );
    }

    setData(result);
  } catch (err) {
    console.error('Search error:', err);
    setData([]);
  }
};




  const handleReset = () => {
    setPendingHostelFilter('');
    setPendingHostelerFilter('');
    setFormData({ cityId: '' });
    setData(hostelList);
  };

  const handleViewDetails = useCallback((hostel) => {
    axiosApi.post(`${API_BASE_URL}/hostel/getHostelDetails`, {
      hostelSearchCriteria: { hostelIds: [hostel.id] }
    })
      .then(response => {
        const details = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : response.data;
        setSelectedHostelDetails(details);
        setOpenDetails(true);
      })
      .catch(err => console.error("Error fetching hostel details:", err));
  }, []);

const handleViewMenu = useCallback(async (hostel) => {
  try {
    // Get hostel details first
    const hostelResponse = await axiosApi.post(
      `${API_BASE_URL}/hostel/getHostels`,
      {
        hostelSearchCriteria: {
          hostelIds: [hostel.id]
        }
      }
    );

    const hostelData =
      hostelResponse.data?.hostels?.[0] ||
      hostelResponse.data?.[0];

    const menuType = hostelData?.menuType;

    // STANDARD MENU
    if (menuType === "STANDARD") {
      setSelectedHostelMenu({
        hostelName: hostel.hostelName
      });

      setMenuErrorMessage('');
      setOpenMenu(true);
      return;
    }

    // WEEKLY MENU
    const response = await axiosApi.post(
      `${API_BASE_URL}/hostelMenu/getHostelMenu`,
      {
        hostelIds: [hostel.id]
      }
    );

    const menuDataArray = Array.isArray(response.data)
      ? response.data
      : [];

    if (!menuDataArray.length) {
      setSelectedHostelMenu(null);
      setMenuErrorMessage("No menu items created.");
      setOpenMenu(true);
      return;
    }

    const initialDailyMenu = {
      Monday: {},
      Tuesday: {},
      Wednesday: {},
      Thursday: {},
      Friday: {},
      Saturday: {},
      Sunday: {}
    };

    menuDataArray.forEach((item) => {
      if (item.dayOfWeek && initialDailyMenu[item.dayOfWeek]) {
        initialDailyMenu[item.dayOfWeek] = {
          breakfast: item.breakfastItems || '',
          lunch: item.lunchItems || '',
          snacks: item.snacksItems || '',
          dinner: item.dinnerItems || '',
        };
      }
    });

    setSelectedHostelMenu({
      hostelName: hostel.hostelName,
      dailyMenu: initialDailyMenu
    });

    setMenuErrorMessage('');
    setOpenMenu(true);

  } catch (err) {
    console.error(err);
  }
}, []);

  const handleDelete = (hostelId) => {
    axiosApi.post(`${API_BASE_URL}/hostel/deleteHostel`, {
      hostelSearchCriteria: { hostelIds: [hostelId] }
    })
      .then(() => {
        setDeleteMessage(`Hostel with ID ${hostelId} has been deleted.`);
        axiosApi.post(`${API_BASE_URL}/hostel/getHostels`, {})
          .then(response => {
            const updated = Array.isArray(response.data) ? response.data : [];
            setHostelList(updated);
            setData(updated);
          });
      })
      .catch(error => {
        console.error("Error deleting hostel:", error);
        setDeleteMessage("Failed to delete the hostel. Please try again.");
      });
  };



const handleViewHoliday = useCallback((hostel) => {
  console.log("Opening holiday dialog for hostel:", hostel.id);
  // ✅ store the current hostelId in state
  setSelectedHostelId(hostel.id);
  axiosApi.post(`${API_BASE_URL}/hostelHolidayOrClosure/getHostelHolidayOrClosure`, { hostelIds: [hostel.id] })
    .then(response => {
      const holidayData = Array.isArray(response.data) ? response.data : [];
      const normalized = holidayData.map(h => ({
        name: h.name || "",
		scheduleType: h.scheduleType || "-",
        startDate: h.startDate || "",
        endDate: h.endDate || "",
		hostelId:h.hostelId,
		id:h.id,
		hostelName:h.hostelName || "",
        stayClosed: h.stayClosed === true || h.stayClosed === "true" || h.stayClosed === "Y",
        foodNotAvailable: h.foodNotAvailable === true || h.foodNotAvailable === "true" || h.foodNotAvailable === "Y",
        remarks: h.remarks || ""
      }));
      setHolidayList(normalized);
      setOpenHoliday(true);
      console.log("Holiday dialog state set to OPEN ✅", normalized);
    })
    .catch(err => console.error("Error fetching hostel holiday:", err));
}, []);


const handleViewHostelerCount = useCallback((hostel) => {
  setSelectedHostelForOccupancy(hostel);
  setOpenOccupancyDialog(true);
  setRoomTypes([]); // reset previous data

  setOccupancyLoading(true);

  axiosApi
    .post("/roomTypeOccupancy/getRoomTypeOccupancy", {
      hostelId: hostel.id,
      disablePagination: true
    })
    .then((res) => {
      const occupancyData = Array.isArray(res.data) ? res.data : [];

      const formatted = occupancyData.map((room) => ({
        id: room.roomTypeId,
        roomType: room.roomType,
        description: room.description || "",
        tenantCount: room.tenantCount ?? ""  // keep empty if null
      }));

      setRoomTypes(formatted);
    })
    .catch((err) => {
      console.error("Error fetching room occupancy:", err);
      setRoomTypes([]);
    })
    .finally(() => {
      setOccupancyLoading(false);
    });

}, []);



const handleOccupancyChange = (index, value) => {
  // Prevent negative numbers
  if (value !== "" && Number(value) < 0) return;

  const updated = [...roomTypes];
  updated[index].tenantCount = value;
  setRoomTypes(updated);
};


const handleSaveOccupancy = async () => {

  const hasInvalid = roomTypes.some(
    (room) =>
      room.tenantCount === "" ||
      room.tenantCount === null ||
      isNaN(room.tenantCount) ||
      Number(room.tenantCount) < 0
  );

  if (hasInvalid) {
    setBanner({
      open: true,
      type: "error",
      message: "Please enter valid tenant count for all room types."
    });
    return false; // stop execution
  }

  const payload = {
    hostelId: selectedHostelForOccupancy?.id,
    roomTypeOccupancyDTOs: roomTypes.map((room) => ({
      roomTypeId: room.id,
      tenantCount: Number(room.tenantCount)
    }))
  };

  try {
    await axiosApi.post(
      "/roomTypeOccupancy/updateRoomTypeOccupancy",
      payload
    );
    return true;
  } catch (err) {
    console.error("Error updating occupancy:", err);
    throw err;
  }
};


const handleUpdateClick = async () => {
  try {
    setSaving(true);

    const success = await handleSaveOccupancy();

    if (!success) {
      setSaving(false);
      return;
    }

    setBanner({
      open: true,
      type: "success",
      message: "Room occupancy updated successfully."
    });

    // Optional: close dialog after success
    // setOpenOccupancyDialog(false);

  } catch (error) {
    setBanner({
      open: true,
      type: "error",
      message: "Failed to update room occupancy. Please try again."
    });
  } finally {
    setSaving(false);
  }
};




  const handleCloseDetails = () => setOpenDetails(false);
  const handleCloseMenu = () => {
  setSelectedHostelMenu(null); // clear previous menu
  setMenuErrorMessage('');      // clear any warning
  setOpenMenu(false);           // close dialog
};



const [openHoliday, setOpenHoliday] = useState(false);
  const [holidayList, setHolidayList] = useState([]);
  //const [saveStatus, setSaveStatus] = useState(null); // "success" | "error"

  /*const handleOpenHoliday = () => {
    setOpenHoliday(true);
  };*/

  /*const handleCloseHoliday = () => {
    setOpenHoliday(false);
    setSaveStatus(null);
  };*/

  
  const columns = React.useMemo(() => [
    { Header: 'Property Name', accessor: 'hostelName' },
    { Header: 'Country', accessor: 'countryName' },
    { Header: 'State', accessor: 'stateName' },
    { Header: 'City', accessor: 'cityName' },
    { Header: 'Review', accessor: 'review' },
    {
  Header: 'Actions',
  Cell: ({ row }) => {
    const hostel = row.original;

    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        <Button
          disabled={!checkPermission("Hostel", "Hostel List", "VIEWDETAILS")}
          size="small"
          variant="outlined"
          onClick={() => handleViewDetails(hostel)}
        >
          Details
        </Button>

        <Button
          disabled={!checkPermission("Hostel", "Hostel List", "VIEWMENUDETAILS")}
          size="small"
          variant="outlined"
          onClick={() => handleViewMenu(hostel)}
        >
          Menu
        </Button>

        {/* ✅ Show Holiday ONLY if reservationOnly is FALSE */}
        {!hostel.reservationOnly && (
          <Button
            disabled={!checkPermission("Hostel", "Hostel List", "VIEWHOLIDAYDETAILS")}
            size="small"
            variant="outlined"
            onClick={() => handleViewHoliday(hostel)}
          >
            Holiday
          </Button>
        )}

        {/* ✅ Show VIEW Hostler count ONLY if reservationOnly is TRUE */}
        {hostel.reservationOnly && (
          <Button
            disabled={!checkPermission("Hostel", "Hostel List", "VIEWROOMOCCUPANCY")}
            size="small"
            variant="outlined"
            onClick={() => handleViewHostelerCount(hostel)}  // 👈 create this function
          >
            Occupancy
          </Button>
        )}

        <Button
          disabled={!checkPermission("Hostel", "Hostel List", "DELETE")}
          size="small"
          color="error"
          variant="outlined"
          onClick={() => {
            setDeleteConfirmId(hostel.id);
            setShowDeleteConfirm(true);
          }}
        >
          Delete
        </Button>
      </div>
    );
  },
}

  ], [handleViewDetails, handleViewMenu, handleViewHoliday,handleViewHostelerCount]);

  const {
    getTableProps, getTableBodyProps, headerGroups, rows, prepareRow,
    state: { pageIndex, pageSize },
    pageCount, gotoPage, setPageSize
  } = useTable(
    { columns, data, initialState: { pageIndex: 0, pageSize: 5 } },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push(columns => [
        {
          id: 'selection',
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <input type="checkbox" {...getToggleAllRowsSelectedProps()} />
          ),
          Cell: ({ row }) => (
            <input type="checkbox" {...row.getToggleRowSelectedProps()} />
          ),
        },
        ...columns,
      ]);
    }
  );

  if (loading) return <p>Loading hostels...</p>;
  
  
  
  

  return (
    <>
      <HeaderMenu />
      <div >
     <Grid
  container
  spacing={2}
  sx={{
    backgroundColor: '#f9f9f9',
    p: 2,
    borderRadius: 2,
    mb: 3,
    boxShadow: 1,
    alignItems: 'center',
  }}
>
  <Grid item xs={12} sm={6} md={3}>
    <FormControl fullWidth size="small">
      <InputLabel>Property Name</InputLabel>
      <Select
        value={pendingHostelFilter}
        onChange={(e) => setPendingHostelFilter(e.target.value)}
        label="Property Name"
      >
        <MenuItem value="">All</MenuItem>
        {hostelList.map((hostel) => (
          <MenuItem key={hostel.id} value={hostel.hostelName}>
            {hostel.hostelName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>

  <Grid item xs={12} sm={6} md={3}>
    <FormControl fullWidth size="small">
      <InputLabel>City</InputLabel>
      <Select
        name="cityId"
        value={formData.cityId}
        onChange={handleInputChange}
        label="City"
      >
        <MenuItem value="">All</MenuItem>
        {cities.map((city) => (
          <MenuItem key={city.id} value={city.id}>
            {city.cityName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  </Grid>

  

  <Grid item xs={12} sm={6} md={3} container spacing={1}>
    <Grid item>
      <Button variant="contained" size="small" onClick={handleSearch}>
        Search
      </Button>
    </Grid>
    <Grid item>
      <Button variant="outlined" size="small" color="secondary" onClick={handleReset}>
        Reset
      </Button>
    </Grid>
  </Grid>
</Grid>




        {menuErrorMessage && (
          <Alert severity="warning" onClose={() => setMenuErrorMessage('')}>{menuErrorMessage}</Alert>
        )}

        {deleteMessage && (
          <Alert severity="success" onClose={() => setDeleteMessage('')}>{deleteMessage}</Alert>
        )}

        <div className="table-container">
          <table {...getTableProps()} className="table">
            <thead>
              {headerGroups.map(headerGroup => (
                <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th key={column.id} {...column.getHeaderProps()}>{column.render('Header')}</th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map(row => {
                prepareRow(row);
                return (
                  <tr key={row.id} {...row.getRowProps()}>
                   {row.cells.map(cell => (
  <td
    key={cell.column.id}
    {...cell.getCellProps()}
    data-label={cell.column.Header}  // 👈 ADD THIS
  >
    {cell.render('Cell')}
  </td>
))}

                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
          <Pagination count={pageCount} page={pageIndex + 1} onChange={(e, value) => gotoPage(value - 1)} color="primary" shape="rounded" />
          <div>
            <label htmlFor="rows-per-page" style={{ marginRight: '8px' }}>Rows per page:</label>
            <select id="rows-per-page" value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
              {[5, 10, 15, 20].map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </select>
          </div>
        </div>

     <Dialog
  open={openDetails}
  onClose={(event, reason) => {
    // Prevent closing when clicking outside or pressing ESC
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    handleCloseDetails();
  }}
  fullWidth
  maxWidth="xl"
  PaperProps={{
    sx: {
      '@media (max-width:768px)': {
        width: '100%',
        maxWidth: '100%',
        height: '100vh',
        margin: 0,
        borderRadius: 0,
      },
    },
  }}
>
  <DialogTitle>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <span>Hostel Details</span>
      
    </Stack>
  </DialogTitle>

  <DialogContent>
    {selectedHostelDetails && (
      <CreateHostel
        hostel={selectedHostelDetails}
        isDialog={true}
        onClose={handleCloseDetails}   // ✅ Close button inside form
      />
    )}
  </DialogContent>
</Dialog>




   {/* Holiday / Closure Management Dialog */}
<HolidayDialog
  openDialog={openHoliday}
  handleCloseHoliday={() => setOpenHoliday(false)}
  holidays={holidayList}   // pass API result here
  hostelId={selectedHostelId}    // 👈 MAKE SURE this comes from your parent state
  onSave={(updated) => setHolidayList(updated)} // keep parent in sync
/>


<Dialog
  open={openMenu}
  onClose={(event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    handleCloseMenu();
  }}
  fullWidth
  maxWidth="xl"
>
  <DialogTitle>
  <Stack direction="row" justifyContent="space-between" alignItems="center">
    <span>Hostel Menu</span>

    {!selectedHostelMenu && (
      <IconButton
        onClick={handleCloseMenu}
        size="small"
        sx={{
          width: 24,       // ✅ reduce icon button length (width)
          height: 24,      // ✅ reduce icon button height
          p: 0,            // remove padding
          minWidth: 0,     // prevent MUI from forcing min width
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    )}
  </Stack>
</DialogTitle>



  <DialogContent>
    {selectedHostelMenu ? (
      <CreateHostelMenu
        hostel={selectedHostelMenu}
        onClose={handleCloseMenu}
        isDialog={true}
      />
    ) : (
      <Alert severity="info">No menu available for this hostel.</Alert>
    )}
  </DialogContent>
</Dialog>

<Dialog
  open={openOccupancyDialog}
  onClose={(event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
    setOpenOccupancyDialog(false);
  }}
  fullWidth
  maxWidth="sm"
  PaperProps={{
    sx: {
      borderRadius: 3,
      overflow: "hidden"
    }
  }}
>
  {/* ---------- HEADER ---------- */}
  <DialogTitle
    sx={{
      backgroundColor: "#f5f7fa",
      fontWeight: 600,
      fontSize: "1.1rem",
      borderBottom: "1px solid #e0e0e0"
    }}
  >
    Room Type Occupancy – {selectedHostelForOccupancy?.hostelName}
  </DialogTitle>

  {/* ---------- CONTENT ---------- */}
  <DialogContent sx={{ py: 3 }}>

    {/* ✅ Banner Message */}
    {banner.open && (
      <Alert
        severity={banner.type}
        sx={{ mb: 2 }}
        onClose={() => setBanner({ ...banner, open: false })}
      >
        {banner.message}
      </Alert>
    )}

    {occupancyLoading && (
      <Alert severity="info" sx={{ mb: 2 }}>
        Loading room types...
      </Alert>
    )}

    {!occupancyLoading && roomTypes.length === 0 && (
      <Alert severity="info" sx={{ borderRadius: 2 }}>
        No Room Types Available
      </Alert>
    )}

    {!occupancyLoading && roomTypes.length > 0 && (
      <Stack spacing={3}>
        {roomTypes.map((room, index) => (
          <Grid
            container
            key={room.roomTypeId}
            alignItems="center"
            sx={{
              py: 1.5,
              borderBottom:
                index !== roomTypes.length - 1
                  ? "1px solid #f0f0f0"
                  : "none"
            }}
          >
            <Grid item xs={12} sm={6}>
              <div
                style={{
                  fontWeight: 500,
                  fontSize: "0.95rem"
                }}
              >
                {room.roomType}
              </div>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Tenant Count"
                type="number"
                size="small"
                fullWidth
                inputProps={{ min: 0 }}
                value={room.tenantCount ?? 0}
                onChange={(e) => {
                  let value = e.target.value;

                  if (value === "" || value === null) {
                    value = 0; // ✅ Auto set empty to 0
                  }

                  handleOccupancyChange(index, Number(value));
                }}
              />
            </Grid>
          </Grid>
        ))}
      </Stack>
    )}
  </DialogContent>

  {/* ---------- FOOTER ---------- */}
  {!occupancyLoading && (
    <Stack
      direction="row"
      justifyContent="flex-end"
      spacing={2}
      sx={{
        px: 3,
        py: 2,
        borderTop: "1px solid #e0e0e0",
        backgroundColor: "#fafafa"
      }}
    >
      <Button
        variant="outlined"
        onClick={() => setOpenOccupancyDialog(false)}
      >
        Cancel
      </Button>

      {roomTypes.length > 0 && (
        <Button
          variant="contained"
          onClick={handleUpdateClick}
          disabled={!hasPermission || saving}
        >
          {saving ? "Updating..." : "Update"}
        </Button>
      )}
    </Stack>
  )}
</Dialog>







		
		<Dialog
  open={showDeleteConfirm}
  onClose={() => setShowDeleteConfirm(false)}
  maxWidth="xs"
  fullWidth
>
  <DialogTitle>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
     
      
    </Stack>
  </DialogTitle>
  <DialogContent sx={{ textAlign: 'center', p: 3 }}>
    <p>Are you sure you want to delete this hostel?</p>
    <Stack direction="row" spacing={2} justifyContent="center" mt={3}>
      <Button
        variant="contained"
        color="error"
        onClick={() => {
          handleDelete(deleteConfirmId);
          setShowDeleteConfirm(false);
        }}
      >
        Yes, Delete
      </Button>
      <Button
        variant="outlined"
        onClick={() => setShowDeleteConfirm(false)}
      >
        Cancel
      </Button>
    </Stack>
  </DialogContent>
</Dialog>




      </div>
    </>
  );
};

export default HostelList;
